import { createSlice } from '@reduxjs/toolkit'
import { IDepartment } from 'models/Department/IDepartment'

export interface DepartmentState {
  isLoading: boolean
  isGetDepartmentSuccess: boolean
  isGetDepartmentDetailsSuccess: boolean
  departmentsData: IDepartment[] | null
  departmentDetails: IDepartment[] | null
}

const initialState: DepartmentState = {
  isLoading: false,
  isGetDepartmentSuccess: false,
  isGetDepartmentDetailsSuccess: false,
  departmentsData: null,
  departmentDetails: null,
}

const departmentSlice = createSlice({
  name: 'department',
  initialState,
  reducers: {
    apiRequest: (state) => {
      state.isLoading = true
    },
    apiFailure: (state) => {
      state.isLoading = false
    },
    getDepartments(state, action) {
      state.isLoading = false
      state.isGetDepartmentSuccess = true
      state.departmentsData = action.payload.departmentsData.result
    },
    getDepartmentDetails(state, action) {
      state.isLoading = false
      state.isGetDepartmentDetailsSuccess = true
      state.departmentDetails = action.payload.departmentDetails.result
    },
    clearDepartmentDetails: (state) => {
      state.isGetDepartmentDetailsSuccess = false
      state.departmentDetails = null
    },
  },
})

export const {
  apiRequest,
  apiFailure,
  getDepartments,
  getDepartmentDetails,
  clearDepartmentDetails,
} = departmentSlice.actions

export default departmentSlice.reducer
